import { RootState } from '../../store'
import { ServerKeys } from './types'

export const selectServerUrl =
  (key: ServerKeys) =>
  (state: RootState): string | null => {
    const selectedRegionId = state.regions.selectedId
    const serverUrl = state.servers.urls[key]?.url

    if (!serverUrl || !selectedRegionId) return null

    return serverUrl.replace('{region}', selectedRegionId)
  }
